import { VoidReportField } from "src/app/enums/Report/ReportField/VoidReportField";
import { IReportSortDefinition } from "../Components/IReportSortDefinition";
import { DateRangeParameter } from "./DateRangeParameter";
import { BaseReportParameters } from "./BaseReportParameters";

const localStorageFormParametersProperty = 'VoidReportParameters';

export class VoidReportParameters extends BaseReportParameters {
  reportGroup: VoidReportField;
  createdPosId: number;
  createdClerkId: number;
  voidedDateRange: DateRangeParameter;
  voidedPosId: number;
  voidedClerkId: number;
  sort: IReportSortDefinition[];

  constructor() {
    super(localStorageFormParametersProperty);
  }

  protected getParameters(storedParameters: VoidReportParameters) {
    this.reportGroup = <VoidReportField>(storedParameters?.reportGroup ?? VoidReportField.None);
    this.createdPosId = storedParameters?.createdPosId ?? -1;
    this.createdClerkId = storedParameters?.createdClerkId ?? -1;
    this.voidedDateRange = new DateRangeParameter(storedParameters?.voidedDateRange);
    this.voidedPosId = storedParameters?.voidedPosId ?? -1;
    this.voidedClerkId = storedParameters?.voidedClerkId ?? -1;
  }
}
